module.exports = __webpack_public_path__ + "img/dashboard-management.7d5fe8e6.png";